import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { ReactRelayContext } from 'react-relay';
import serverVars from 'server-vars';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { shoppingWithRoot } from '../shoppingWith/shoppingWithRoot';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import * as tracking from 'dibs-tracking';
import { ShoppingWithWrapper } from '../shoppingWith/ShoppingWithWrapper';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import { ServerVarsContextProvider } from '../sharedComponents/ServerVarsContext';
import get from 'lodash.get';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const variables = serverVars.get('relayVariables');

const operation = createOperationDescriptor(getRequest(shoppingWithRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(({ store }) => {
    ReactDOM.hydrate(
        <Provider store={store}>
            <IntlProvider
                locale={serverVars.get('localeDataKey')}
                messages={serverVars.get('messages')}
            >
                <ServerVarsContextProvider
                    isMobile={serverVars.get('settings.isMobile')}
                    isTablet={serverVars.get('settings.isTablet')}
                    isDesktop={serverVars.get('settings.isDesktop')}
                >
                    <ReactRelayContext.Provider
                        value={{
                            environment,
                            variables: snapshot.variables || {},
                        }}
                    >
                        <ShoppingWithWrapper
                            relayEnvironment={environment}
                            shoppingWith={get(snapshot, 'data.viewer.shoppingWith')}
                            viewer={get(snapshot, 'data.viewer')}
                        />
                    </ReactRelayContext.Provider>
                </ServerVarsContextProvider>
            </IntlProvider>
        </Provider>,
        document.getElementById('js-root')
    );
    tracking.trackPageview();
});
